export const convertStringNumbers = (
  obj: Record<string, unknown>
): Record<string, unknown> => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      // 只處理 string 或 number
      if (typeof value === 'string' || typeof value === 'number') {
        const num = Number(value);
        // 如果轉成數字後不是 NaN，就用數字；否則保留原值
        return [key, Number.isNaN(num) ? value : num];
      }
      // 其他型別原樣返回
      return [key, value];
    })
  );
}